import React from 'react';

import { withStyles } from '@material-ui/core';

import Pagination from "components/Pagination/Pagination.jsx";
import FormControl from "@material-ui/core/FormControl";

import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import datatableFooterStyles from 'assets/jss/material-dashboard-pro-react/datatableFooterStyles';

//(count, page, rowsPerPage, changeRowsPerPage, changePage)

class DataTableFooter extends React.Component {
    render() {

        const { count, page, rowsPerPage, changeRowsPerPage, changePage, classes } = this.props;

        const adjustedCount = Math.floor(count / rowsPerPage);

        const beforeCurrentPage = [];

        const afterCurrentPage = [];

        if (page > 0) {
            beforeCurrentPage[0] = { text: "FIRST", onClick: () => changePage(0) };
            beforeCurrentPage[1] = { text: "PREV", onClick: () => changePage(page - 1) };
        }
        else {
            beforeCurrentPage[0] = { text: "FIRST", active: true };
            beforeCurrentPage[1] = { text: "PREV", disabled: true };
        }

        if (page >= 2) {
            beforeCurrentPage[2] = { text: page - 1, onClick: () => changePage(page - 2) }
            beforeCurrentPage[3] = { text: page, onClick: () => changePage(page - 1) }
        } else {
            if (page === 1)
                beforeCurrentPage[3] = { text: 1, onClick: () => changePage(0) }
            else
                beforeCurrentPage[3] = { text: " ", disabled: true };

            beforeCurrentPage[2] = { text: " ", disabled: true };
        }

        if (page <= (adjustedCount - 2)) {
            afterCurrentPage[0] = { text: page + 2, onClick: () => changePage(page + 1) }
            afterCurrentPage[1] = { text: page + 3, onClick: () => changePage(page + 2) }
        } else {
            if (page < adjustedCount)
                afterCurrentPage[0] = { text: page + 2, onClick: () => changePage(page + 1) }
            else
                afterCurrentPage[0] = { text: " ", disabled: true };
            afterCurrentPage[1] = { text: " ", disabled: true };
        }

        if (page < adjustedCount) {
            afterCurrentPage[2] = { text: "NEXT", onClick: () => changePage(page + 1) };
            afterCurrentPage[3] = { text: "LAST", onClick: () => changePage(adjustedCount) };
        } else {
            afterCurrentPage[2] = { text: "NEXT", disabled: true };
            afterCurrentPage[3] = { text: "LAST", active: true };
        }

        return (
            <tbody>
                <tr>
                    <td className={classes.footerContainer}>
                        <Pagination
                            className={classes.pagination}
                            pages={[
                                ...beforeCurrentPage,
                                { active: true, text: (page + 1) },
                                ...afterCurrentPage
                            ]}
                            color="info"
                        />

                        <div className={classes.pageInfoSection}>
                            {count > 0 ? ((page * rowsPerPage) + 1) : 0}-{((page * rowsPerPage) + rowsPerPage) >= count ? count : (page * rowsPerPage) + rowsPerPage} of {count}
                        </div>

                        <div className={classes.pagesPerRowContainer}>
                            <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                            >
                                <InputLabel
                                    htmlFor="rowsPerPage"
                                    className={classes.selectLabel}
                                    shrink
                                >
                                    Rows Per Page
                            </InputLabel>
                                <Select
                                    MenuProps={{
                                        className: classes.selectMenu,
                                        style: { display: 'inline-block', width: 'auto', marginTop: 16, maxWidth: 40 }
                                    }}
                                    classes={{
                                        select: classes.select
                                    }}
                                    value={rowsPerPage}
                                    onChange={(event) => changeRowsPerPage(event.target.value)}
                                    inputProps={{
                                        name: "rowsPerPage",
                                        id: "rowsPerPage"
                                    }}
                                    color="info"
                                >
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value={10}>
                                        10
                                </MenuItem>
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value={25}>
                                        25
                                </MenuItem>
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value={50}>
                                        50
                                </MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </td>
                </tr>
            </tbody>
        );
    }
}

export default withStyles(datatableFooterStyles)(DataTableFooter)